<template lang="pug">
.t-landing-page
  CommonHeader(title="")
  //- 加载页
  LoadingPage(v-if="showLoading")

  //- 错误页（包含无场景的情况）
  ErrorPage(
    v-else-if="displayDefault || !hasScene"
    :isLogin="isLogin"
    :msg="errorMsg || '暂无活动信息'"
    :code="errorCode"
    :haCode="haCode"
    @refresh="init"
  )

  //- 主内容
  .container(v-else)
    //- 背景图
    .bg-container
      img.bg-img(:src="bgImg" alt="背景")

    //- 页面标题
    PageMainTitle(v-if="pageTitle" :title="pageTitle")

    //- 中间内容区（动态卡片信息）
    .middle-container
      //- 签约成功后显示成功卡片（包含按钮）
      SuccessCardInfo(
        v-if="signIn"
        :cardInfo="cardInfo"
        :buttonText="signInButtonText"
        @button-click="handleSuccessAction"
      )
      //- 签约前显示普通卡片
      component(
        v-else
        :is="currentCardComponent"
        :cardInfo="cardInfo"
      )

    //- 按钮区域（仅在未签约时显示）
    .action-box(v-if="!signIn")
      //- 优惠卡片（未签约时显示）
      SubsidyCard(
        v-if="!signIn && subsidyPrice"
        :subsidyPrice="subsidyPrice"
        :subsidyPic="subsidyPic"
      )

      //- 主按钮
      component(
        :is="currentButtonComponent"
        :buttonMainText="buttonMainText"
        :buttonSubText="buttonSubText"
        @click="handleButtonClick"
      )

      //- 临期提醒（未签约时显示）
      .expire-tips(v-if="!signIn") {{ expireTips || "首次开通抖音免密支付用户享更多优惠" }}

    //- 售卡模块
    //- CardSaleModel(
    //-   v-if="showCardSaleModel"
    //-   :filterGoods="filterGoods"
    //-   :goodsTagMapping="goodsTagMapping"
    //-   :categoryIds="categoryIds"
    //-   :adsource="adsource"
    //-   :spuId="spuId"
    //- )
</template>

<script>
import { getTokenAndLocation, safeGet, getTokenAndKey } from '@/utils';
import { getTiktokPlanInfo, getDynamicHaCommand } from '@/api/tiktokSign';
import { getVersion, getSystemCode } from '@/utils/systemCode';
import config from '@/const/config';

import Toast from '@/components/toast';
import Loading from '@/components/loading';
import CommonHeader from '@/components/common-header';
import SPM from './common/spm';
import {
  createOrder,
  callDouYinPayAndSign,
  queryDouYinSignResult,
  activeCardHelper,
} from './common/helper';
import {
  COMPONENT_MAP,
  BUTTON_MAP,
  SCENE_TYPE,
  CHARGE_TYPE,
  ORDER_TYPE,
  ACTION_TYPE,
  LOW_VERSION_CODE,
  MIN_APP_VERSION,
  CARD_TYPE,
  BUSINESS_TYPE,
  SUB_SCENE_MAP,
} from './common/const';

// 组件引入
import LoadingPage from './components/loadingPage.vue';
import ErrorPage from './components/errorPage.vue';
import PageMainTitle from './components/page-main-title.vue';
import SubsidyCard from './components/subsidy-card.vue';
import SuccessCardInfo from './components/success-card-info.vue';

export default {
  name: 'TLandingPage',
  components: {
    LoadingPage,
    ErrorPage,
    PageMainTitle,
    SubsidyCard,
    CommonHeader,
    SuccessCardInfo,
    ...COMPONENT_MAP, // 动态卡片组件
    ...BUTTON_MAP, // 动态按钮组件
  },
  data() {
    return {
      // === 页面状态 ===
      showLoading: true, // 加载状态
      displayDefault: false, // 错误页显示
      errorMsg: '', // 错误信息
      errorCode: null, // 错误码
      isLogin: false, // 登录状态
      haCode: '', // 哈口令（后端下发）

      // === 页面配置 ===
      pageTitle: '', // 页面标题

      // === 场景相关 ===
      sceneType: '', // 场景类型
      signIn: false, // 签约状态

      // === 用户信息 ===
      cityCode: '', // 城市编码
      userNewId: '', // 用户ID

      // === 卡片数据 ===
      cardInfo: {}, // 卡片信息（前端渲染）

      // === 按钮数据 ===
      buttonMainText: '', // 按钮主文案
      buttonSubText: '', // 按钮副文案
      buttonBgImg: '', // 按钮背景图
      expireTips: '', // 临期提醒

      // === 签约成功后数据 ===
      signInButtonText: '去换电', // 签约成功后按钮文案
      signInJumpUrl: '', // 签约成功后跳转链接（后端下发）

      // === 优惠数据 ===
      subsidyPrice: null, // 补贴金额
      subsidyPic: 'https://m.hellobike.com/4a591938d0.png', // 补贴图片

      // === 支付参数 ===
      payParams: {}, // 支付参数

      // === 售卡模块 ===
      showCardSaleModel: false, // 售卡模块显示
      filterGoods: [], // 过滤商品列表
      goodsTagMapping: {}, // 商品Tag映射关系（用于埋点）
      categoryIds: [], // 分类ID列表
      spuId: '', // 当前商品SPU ID（用于埋点）

      // === URL 参数 ===
      adsource: '', // 渠道来源（固定：swapHa）
      batchCode: '', // 批次号
    };
  },
  computed: {
    bgImg() {
      if (this.sceneType === SCENE_TYPE.HA_SWAP_BATTERY) {
        return 'https://m.hellobike.com/f7b99a2fe3.png';
      }
      return 'https://m.hellobike.com/1ce18aaacf.jpg';
    },
    // 是否有场景，没有的业务场景会展示兜底
    hasScene() {
      return !!this.sceneType && !!COMPONENT_MAP[this.sceneType];
    },
    // 当前卡片组件
    currentCardComponent() {
      return COMPONENT_MAP[this.sceneType] || null;
    },
    // 当前按钮组件
    currentButtonComponent() {
      return BUTTON_MAP[this.sceneType] || null;
    },
    cardType() {
      return CARD_TYPE[SCENE_TYPE.HA_SWAP_BATTERY];
    },
    subSceneMap() {
      // 默认返回换电哈口令配置
      return SUB_SCENE_MAP[this.sceneType];
    },
  },
  mounted() {
    this.init();
  },
  destroyed() {
    this.reportSPM('viewOut');
  },
  methods: {
    // === 初始化 ===
    async init() {
      try {
        this.showLoading = true;
        this.displayDefault = false;

        // 1. 获取 URL 参数
        const { adsource = '', batchCode = '', cardId = '' } = this.$route.query;
        this.adsource = adsource; // swapHa
        this.batchCode = batchCode;
        this.cardId = cardId;

        // 2. 获取用户信息
        const userInfo = await getTokenAndLocation({ needLogin: true });
        const {
          token, userGuid, cityCode, adCode, userNewId,
        } = userInfo;
        this.isLogin = !!token;
        this.cityCode = cityCode; // 保存城市编码
        this.userNewId = userNewId; // 保存用户ID

        // 3. 获取页面数据
        const params = {
          token,
          userGuid,
          cityCode,
          adCode,
          userNewId,
          version: await getVersion(),
          adsource: this.adsource,
          batchCode: this.batchCode,
          cardId: this.cardId,
          planType: 'tiktok_sign',
          cardType: this.cardType,
        };

        const res = await getTiktokPlanInfo(params);

        if (res.code !== 0) {
          throw res.msg;
        }

        // 4. 解析数据
        this.parsePageData(res.data);

        this.showLoading = false;
        // 埋点上报 PV & 模块曝光
        this.reportSPM('view');
      } catch (error) {
        this.showLoading = false;
        this.displayDefault = true;
        this.errorCode = safeGet(window, '__error.code', null);
        this.errorMsg = safeGet(window, '__error.msg', error.msg);
        // 兜底页曝光
        this.reportSPM('empty');
      }
    },

    reportSPM(type) {
      if (this.sceneType !== SCENE_TYPE.HA_SWAP_BATTERY) return;

      const {
        signIn,
      } = this;

      if (type === 'view') {
        if (signIn) {
          SPM.pageView.platform_tt_huandian_finish.call(this);
          SPM.moduleExpose.platform_tt_huandian_finish_buttun.call(this);
        } else {
          SPM.pageView.platform_tt_huandian.call(this);
          SPM.moduleExpose.platform_tt_huandian_buttun.call(this);
        }
      } else if (type === 'empty') {
        SPM.moduleExpose.platform_tt_huandian_empty.call(this);
      } else if (type === 'viewOut') {
        if (signIn) {
          SPM.pageViewOut.platform_tt_huandian_finish.call(this);
        } else {
          SPM.pageViewOut.platform_tt_huandian.call(this);
        }
      }
    },

    processCardInfo(data) {
      const externalCardInfo = safeGet(data, 'planInfo.externalCardInfo', {});
      switch (this.sceneType) {
        case SCENE_TYPE.HA_SWAP_BATTERY:
          this.processSwapHaData(externalCardInfo);
          break;
        default:
          this.processSwapHaData(externalCardInfo);
          break;
      }
    },

    processSwapHaData(data) {
      const {
        cardMainTitle = '', // 卡片主标题
        cardSubTitle = '', // 卡片副标题（如 {30}天{不限}次）
        cardPrice = '', // 卡片价格
        useTip = '', // 使用提示（如 限上海市）
        isAppOnly = false, // 是否仅限App
        useDesc = [], // 使用说明数组
        mainTitle = '', // 主标题（未签约时显示）
        subsidyPrice = null,
        activateEndTime = '',
      } = data;

      this.cardInfo = {
        mainTitle, // 主标题（未签约时显示）
        cardMainTitle, // 卡片主标题
        cardSubTitle, // 卡片副标题（支持高亮格式，如 {30}天{不限}次）
        cardPrice, // 卡片价格
        useTip, // 使用提示（如 限上海市）
        isAppOnly, // 是否仅限App（显示"仅限APP"标签）
        useDesc, // 使用说明数组（底部说明文字）
      };

      // 按钮数据
      const {
        buttonMainTitle = '',
        buttonSubtitle = '',
        batteryRedirectLink = '',
        payParams = null,
        propertyId = '',
      } = data;

      this.buttonMainText = buttonMainTitle;
      this.buttonSubText = buttonSubtitle;
      this.batteryRedirectLink = batteryRedirectLink;
      this.subsidyPrice = subsidyPrice;
      this.activeCardGuid = propertyId;
      this.payParams = {
        ...payParams,
        bizScene: payParams && payParams.biz_scene,
      };
      this.expireTips = activateEndTime;
    },

    // === 解析页面数据 ===
    // 如果业务场景取之根目前不一致，拆分出去。
    parsePageData(data) {
      const {
        signIn = false,
        planType = '',
      } = data;
      // 基础信息
      this.sceneType = safeGet(data, 'planInfo.externalCardInfo.sceneType', '');
      this.pageTitle = safeGet(data, 'planInfo.externalCardInfo.pageTitle', '');
      this.goods = safeGet(data, 'planInfo.goodsList.0', null);

      this.planType = planType;
      this.signIn = signIn;

      // 卡片信息（从后端接口返回的数据中获取）+ 按钮展示信息
      this.processCardInfo(data);
    },

    // === 按钮点击事件 ===
    async handleButtonClick() {
      if (this.sceneType === SCENE_TYPE.HA_SWAP_BATTERY) {
        SPM.clickButton.platform_tt_huandian_buttun.call(this);
      }
      // 未签约时才能点击支付按钮
      switch (this.sceneType) {
        case SCENE_TYPE.HA_SWAP_BATTERY:
          if (await this.checkAppVersion()) {
            this.handlePayAndSign();
          }
          break;
        default:
          if (await this.checkAppVersion()) {
            this.handlePayAndSign();
          }
          break;
      }
    },

    // === 签约成功后的按钮点击处理 ===
    handleSuccessAction() {
      if (this.sceneType === SCENE_TYPE.HA_SWAP_BATTERY) {
        SPM.clickButton.platform_tt_huandian_finish_buttun.call(this);
      }
      // 根据场景类型执行不同的跳转逻辑
      switch (this.sceneType) {
        case SCENE_TYPE.HA_SWAP_BATTERY:
          // 小哈换电场景：跳转到换电频道
          this.goToJumpUrl();
          break;
        default:
          // 默认：使用后端下发的跳转链接
          this.goToJumpUrl();
      }
    },

    // === 跳转到后端下发的链接 ===
    goToJumpUrl() {
      if (this.batteryRedirectLink) {
        window.location.href = this.batteryRedirectLink;
      } else {
        // TODO: 链接待后端提供
        Toast.show('跳转链接待配置');
      }
    },
    // === 小哈换电版本检查 ===
    async checkAppVersion() {
      // 1. 版本检查
      const currentVersion = await getVersion();
      const versionCheckResult = currentVersion >= MIN_APP_VERSION;

      if (!versionCheckResult) {
        const {
          token, cityCode, adCode,
        } = await getTokenAndLocation();
        const { userNewId } = await getTokenAndKey();
        try {
          const res = await getDynamicHaCommand({
            commandType: '9',
            scene: '22',
            systemCode: getSystemCode(),
            cityCode,
            adCode,
            token,
            userNewId,
            subScene: this.subSceneMap[config.env],
            bizContent: {
              shareCode: window.location.href,
              sceneSign: this.sceneType,
            },
          });
          if (res.code === 0) {
            this.haCode = res.data.command;
          }
        } catch (error) {
          Toast.show('获取哈口令失败');
          throw error;
        } finally {
          // 版本过低
          this.displayDefault = true;
          this.errorCode = LOW_VERSION_CODE;
          this.errorMsg = '抱歉，您的App版本过低，请前往手机应用商店，更新到最新版本';
        }
      }

      return versionCheckResult;
    },
    // === 小哈换电支付并签约 ===
    async handlePayAndSign() {
      try {
        // 2. 创建订单
        Loading.show('订单创建中...');

        const {
          bizScene,
          productTagForDySign,
          hideOrder,
          signMustPay,
        } = this.payParams;

        const {
          spuId,
          skuId,
          salePrice,
        } = this.goods;

        // 获取用户信息
        const { cityCode, userNewId } = await getTokenAndLocation({ needLogin: true });
        const systemCode = getSystemCode();

        const orderParams = {
          orderType: ORDER_TYPE.NORMAL,
          payAmount: this.goods && this.goods.salePrice,
          adsource: this.adsource,
          chargeType: CHARGE_TYPE.HA_SWAP_PAY_AND_SIGN,
          itemList: [{
            spuId,
            skuId,
            num: 1,
            salePrice,
          }],
          hideOrder,
          // 额外参数，不影响下单，平台后端需要的参数，交易透传
          extra: {
            tikTokBizType: ACTION_TYPE[this.sceneType],
            cityCode,
            systemCode,
            userNewId,
            planType: this.planType,
            userCardGuid: this.activeCardGuid,
            businessType: BUSINESS_TYPE[this.sceneType], // 13: 小哈换电需求
            monthlySignIn: false, // 小哈换电默认false，后续业务场景看情况改动
            isBatteryReplacement: this.sceneType === SCENE_TYPE.HA_SWAP_BATTERY,
          },
        };

        if (!bizScene || !productTagForDySign) {
          Toast.show('支付参数错误');
          return;
        }

        const { success, payOrderInfo, msg } = await createOrder(orderParams);
        Loading.close();

        if (!success) {
          Toast.show(msg || '订单创建失败');
          return;
        }

        // 3. 拉起抖音支付并签约
        const payParams = {
          ...payOrderInfo,
          signChannel: 'douyin',
          bizScene,
          productTagForDySign,
          signMustPay,
          tikTokBizType: ACTION_TYPE[this.sceneType],
        };

        const payRes = await callDouYinPayAndSign(payParams);

        if (!payRes.success) {
          // 用户取消支付或支付失败
          return;
        }

        // 4. 查询签约结果
        Loading.show('签约确认中...');

        const signRes = await queryDouYinSignResult({
          planType: this.planType,
          sceneType: this.sceneType,
          maxRetryTime: 15000,
          interval: 1000,
        });

        Loading.close();

        if (signRes.signIn) {
          // 签约成功
          this.signIn = true;
          Toast.show('领取成功');
          this.handleActive();

          if (this.sceneType === SCENE_TYPE.HA_SWAP_BATTERY) {
            // 上报新页面进入
            this.reportSPM('view');
          }
        } else {
          Toast.show('支付签约失败');
        }
      } catch (error) {
        Loading.close();
        // eslint-disable-next-line no-console
        console.error('支付签约失败:', error);
        Toast.show(error.message || '操作失败');
      }
    },

    // 签约成功后废除权益，激活新权益。
    handleActive() {
      switch (this.sceneType) {
        case SCENE_TYPE.HA_SWAP_BATTERY:
          this.handleActiveSwapHa();
          break;
        default:
          break;
      }
    },

    async handleActiveSwapHa() {
      const { success, msg } = await activeCardHelper({
        planType: this.planType,
        systemCode: getSystemCode(),
        userCardGuid: this.activeCardGuid,
        businessType: BUSINESS_TYPE[this.sceneType],
        isBatteryReplacement: this.sceneType === SCENE_TYPE.HA_SWAP_BATTERY,
        sceneType: this.sceneType,
        // 连续包月激活时，传入true
      });
      if (success) {
        Toast.show('领取成功');
        // 免签成功逻辑处理
      } else {
        Loading.close();
        Toast.show(msg || '领取失败');
      }
    },
  },
};
</script>

<style lang="less" scoped>
@font-face {
  font-family: 'MFYuanHei';
  src: url('https://m.hellobike.com/167f3e48_MFYuanHei_Noncommercial-Regular.otf') format('truetype');
  font-weight: medium;
}

.t-landing-page {
  width: 3.75rem;
  min-height: 100vh;
  background-color: #bff6ff;

  .container {
    position: relative;
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    padding-bottom: 1.12rem;
    background: linear-gradient(180deg, #9ef2ff 0%, #9ef2ff 2.43rem, #bff6ff 100%);

    // 背景容器
    .bg-container {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 0;

      .bg-img {
        width: 100%;
        object-fit: cover;
      }
    }

    // 中间内容区
    .middle-container {
      position: relative;
      z-index: 1;
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 0 0.2rem;
      box-sizing: border-box;
      margin-top: 2.43rem;
    }

    // 按钮区域
    .action-box {
      position: relative;
      z-index: 1;
      margin-top: 0.24rem;
      width: 100%;
      box-sizing: border-box;

      // 临期提醒样式
      .expire-tips {
        margin-top: 0.1rem;
        font-size: 0.12rem;
        color: #999;
        text-align: center;
        line-height: 1.5;
      }
    }
  }
}
</style>
